import { createContext } from 'react';

const InitialState = {
  isLoading: true,
  locationBasedAdmin: null,
  voiceActions: null,
  pendoEnv: null,
  bulkImports: null,
  smsEnablementGenerateContent: null,
  isClusterIdInBWPatching: false,
  globalNavigation: false,
  isNewVoicemail: false,
  accountInfoTaxID: false,
  accountInfoTaxIDLink: false,
  purchaseLicenseFlow: false,
  welcomeEmail: false,
  connect: false,
  bulkUsersEdit: false,
  cxPrimaryOwnerRemoval: false,
  smsUseCases: false,
  autom8tly: false,
};

const actionTypes = {
  UPDATE_IS_LOADING: 'UPDATE_IS_LOADING',
  AUTHV3_FLAG: 'AUTHV3_FLAG',
  LOCATION_BASED_ADMIN_FLAG: 'LOCATION_BASED_ADMIN_FLAG',
  EMAIL_ADDRESS_FLAG: 'EMAIL_ADDRESS_FLAG',
  EMAIL_SIGNATURE_FLAG: 'EMAIL_SIGNATURE_FLAG',
  EDIT_USER_LICENSE_FLAG: 'EDIT_USER_LICENSE_FLAG',
  VOICE_ACTIONS_FLAG: 'VOICE_ACTIONS_FLAG',
  EDIT_USER_TEAMS_FLAG: 'EDIT_USER_TEAMS_FLAG',
  PENDO_FLAG: 'PENDO_FLAG',
  BULK_IMPORTS_REARCHITECTURE: 'BULK_IMPORTS_REARCHITECTURE',
  BULK_IMPORTS_TEAMS: 'BULK_IMPORTS_TEAMS',
  BULK_IMPORTS_LOCATIONS: 'BULK_IMPORTS_LOCATIONS',
  BILLING_LICENSING_FLAG: 'BILLING_LICENSING_FLAG',
  IS_CLUSTERID_IN_BW_PATCHING: 'IS_CLUSTERID_IN_BW_PATCHING',
  GLOBAL_NAVIGATION_FLAG: 'GLOBAL_NAVIGATION_FLAG',
  NEW_VOICEMAIL_FLAG: 'NEW_VOICEMAIL_FLAG',
  ACCOUNT_INFO_TAX_ID_FLAG: 'ACCOUNT_INFO_TAX_ID_FLAG',
  ACCOUNT_INFO_TAX_ID_LINK_FLAG: 'ACCOUNT_INFO_TAX_ID_LINK_FLAG',
  SMS_CAMPAIGN_REGISTRY_GENERATE_CONTENT:
    'SMS_CAMPAIGN_REGISTRY_GENERATE_CONTENT',
  SMS_USE_CASES: 'SMS_USE_CASES',
  TEAMS_SMS: 'TEAMS_SMS',
  TEAMS_SMS_LICENSING: 'TEAMS_SMS_LICENSING',
  PURCHASE_LICENSE_FLOW: 'PURCHASE_LICENSE_FLOW',
  WELCOME_EMAIL: 'WELCOME_EMAIL',
  CONNECT_FLAG: 'CONNECT_FLAG',
  GLOBAL_NEXTIVACX_FLOW: 'GLOBAL_NEXTIVACX_FLOW',
  BULK_USERS_EDIT: 'BULK_USERS_EDIT',
  ALLOW_CX_PRIMARY_OWNER_REMOVAL: 'ALLOW_CX_PRIMARY_OWNER_REMOVAL',
  AUTOM8TLY: 'AUTOM8TLY',
};

const FeatureContext = createContext(InitialState);

export { FeatureContext };
export { InitialState };
export { actionTypes };
